module.exports = __webpack_public_path__ + "img/illust-04.fee213f3.png";